// Traducao entre as DUAS perguntas da tela (como compra / como usa) e os tres
// campos gravados no ingrediente (unit, units_per_package, unit_weight).
// Regras (as mesmas do custo em products/cmv.py e da baixa em pedidos/stock.py):
//   embalagem (units_per_package>0) manda: compra em caixa, ficha em un
//   kg + unit_weight → ficha em un   |   un + unit_weight → ficha em kg

export function compraDe({ unit, unitsPerPackage }) {
  if (unit === "kg") return "kg";
  if (unit !== "un") return null; // ainda nao escolheu
  return Number(unitsPerPackage) > 0 ? "caixa" : "un";
}

export function usoDe(v) {
  const compra = compraDe(v);
  if (!compra) return null;
  if (compra === "caixa") return "un";
  const temPeso = Number(v.unitWeight) > 0;
  if (compra === "kg") return temPeso ? "un" : "kg";
  return temPeso ? "kg" : "un";
}

/** {unit, unitsPerPackage, unitWeight} a partir das duas respostas. */
export function derivar(compra, uso, { unitsPerPackage = "", unitWeight = "" } = {}) {
  if (compra === "caixa") return { unit: "un", unitsPerPackage, unitWeight: "" };
  const unit = compra === "kg" ? "kg" : "un";
  const precisaPeso = (compra === "kg" && uso === "un") || (compra === "un" && uso === "kg");
  return { unit, unitsPerPackage: "", unitWeight: precisaPeso ? unitWeight : "" };
}

/** Campos do payload da API a partir do form. */
export function paraPayload({ unit, unitsPerPackage, unitWeight }) {
  const upp = parseInt(unitsPerPackage, 10);
  const uw = parseFloat(unitWeight);
  return {
    unit: unit === "unidade" ? "un" : unit,
    units_per_package: Number.isFinite(upp) && upp > 0 ? upp : 0,
    unit_weight: Number.isFinite(uw) && uw > 0 ? uw : 0,
  };
}

/** Regra do dono (09/09/2026): minimo nunca igual ou maior que o maximo (quando ha maximo). */
export function minMaxValido(stockMin, stockMax) {
  const mn = Number(stockMin) || 0, mx = Number(stockMax) || 0;
  return !(mx > 0 && mn >= mx);
}
